import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Card, CardContent } from '@mui/material';

export default function Welcome() {
  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          STITCH PORTAL
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          <i>Empowering your creativity</i>
        </Typography>
      </Box>

      <Card variant="outlined" sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Manage Workspaces
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Organize and showcase your creative workspaces in one place.
          </Typography>
        </CardContent>
      </Card>

      <Card variant="outlined" sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Track Projects
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Keep track of your ongoing projects and deadlines effortlessly.
          </Typography>
        </CardContent>
      </Card>

      <Card variant="outlined" sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Explore Ideas
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Discover new inspirations and collaborate with others.
          </Typography>
        </CardContent>
      </Card>

      {/* Call to Action */}
      <Box sx={{ mt: 6 }}>
        <Typography variant="h5" gutterBottom>
          Ready to get started?
        </Typography>
        <Button variant="contained" color="primary" component={Link} to="/register" sx={{ mr: 2 }}>
          Register Now
        </Button>
        <Button variant="outlined" color="primary" component={Link} to="/login">
          Login
        </Button>
      </Box>
    </Box>
  );
}
